module.exports = __webpack_public_path__ + "static/media/ios_color.51f84126.svg";